import React from "react";
import { Loader } from "components/common/Icons/Loader/Loader";
import { translateFunc } from "@/utils/translateFunc";
import { useBulkResizerCrop } from "./useBulkResizerCrop";

interface CropAndResetButtonProps {
    imageId: string;
    onClose: () => void;
}

const CropAndResetButton = ({ imageId, onClose }: CropAndResetButtonProps) => {
    const { handleCrop, handleReset, isCropping, isResetting } = useBulkResizerCrop(imageId, {
        onCropComplete: onClose,
    });
    return (
        <div className="flex-shrink-0 w-full flex py-2 gap-2 border-t border-t-irGray-200 dark:border-t-darkSurface-600 px-2">
            <div
                className={`flex-grow h-[46px] cursor-pointer flex items-center justify-center content-center rounded-lg text-irBlue-200 text-center py-2 font-semibold text-xl capitalize border border-irBlue-200 hover:bg-irBlue-400 hover:bg-irGray-200 dark:hover:bg-darkSurface-200 dark:text-white lg:block `}
                onClick={handleCrop}
                data-testid="crop-settings-crop-button"
            >
                {isCropping ? (
                    <div className="flex items-center justify-center">
                        <Loader className="stroke-irBlue-200" width={25} height={25} />
                    </div>
                ) : (
                    translateFunc("crop")
                )}
            </div>
            <div
                className="h-[46px] flex-grow-0 flex-shrink-0 cursor-pointer flex items-center justify-center border-slate-300 dark:border-darkSurface-600 dark:hover:bg-darkSurface-200 dark:hover:text-white border rounded-lg text-gray-900 text-center py- px-6 text-xl capitalize hover:bg-irGray-200 dark:text-white"
                onClick={handleReset}
                data-testid="crop-settings-reset-button"
            >
                {isResetting ? (
                    <Loader className="stroke-[var(--dark-gray)]" width={25} height={25} />
                ) : (
                    translateFunc("reset")
                )}
            </div>
        </div>
    );
};

export default CropAndResetButton;
